;(function(){
  "use strict"

  window.Market = {}
  window.Market.config = {}

})();
